import { v4 as uuidv4 } from "uuid";
import { BaklavaEvent } from "@baklavajs/events";
export class Connection {
    constructor(from, to) {
        this.destructed = false;
        this.events = {
            destruct: new BaklavaEvent(this),
        };
        if (!from || !to) {
            throw new Error("Cannot initialize connection with null/undefined for 'from' or 'to' values");
        }
        this.id = uuidv4();
        this.from = from;
        this.to = to;
        this.from.connectionCount++;
        this.to.connectionCount++;
    }
    destruct() {
        this.events.destruct.emit();
        this.from.connectionCount--;
        this.to.connectionCount--;
        this.destructed = true;
    }
}
/**
 * This class is used for calculation purposes only.
 * It won't alter any state of the connected nodes
 */
export class DummyConnection {
    constructor(from, to) {
        if (!from || !to) {
            throw new Error("Cannot initialize connection with null/undefined for 'from' or 'to' values");
        }
        this.id = uuidv4();
        this.from = from;
        this.to = to;
    }
}
